import request from "./request";

// 密码登录
export function passwordLoginAdmin(data){
  return request({
    url: 'intecl/Login/passwordLoginAdmin',
    method: 'post',
    data:data
  })
}

// 获取验证码
export function sendVerificationCode(data){
  return request({
    url: 'intecl/Login/sendVerificationCode',
    method: 'post',
    data:data
  })
}

// 验证码登录
export function captchaLoginAdmin(data){
  return request({
    url: 'intecl/Login/captchaLoginAdmin',
    method: 'post',
    data:data
  })
}

// 退出登录
export function logoutAdmin(token){
  return request({
    url: 'intecl/Login/logoutAdmin',
    method: 'post',
    headers:{
      'userToken':token
    }
  })
}

// 修改密码
export function updatePassword(data,token){
  return request({
    url: 'intecl/Manage/updatePassword',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 修改用户名
export function updateUserName(data,token){
  return request({
    url: 'intecl/Manage/updateUserName',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取用户信息
export function getUserDetail(token){
  return request({
    url: 'intecl/Manage/getUserDetail',
    method: 'post',
    headers:{
      'userToken':token
    }
  })
}

// 题目列表
export function getTopicList(data,token){
  return request({
    url: 'intecl/Topic/getTopicList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取题目详情
export function getTopicDetail(data,token){
  return request({
    url: 'intecl/Topic/getTopicDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑题目
export function saveTopic(data,token){
  return request({
    url: 'intecl/Topic/saveTopic',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 删除题目
export function delTopic(data,token){
  return request({
    url: 'intecl/Topic/delTopic',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 标签类型列表
export function getLabelTypeList(data,token){
  return request({
    url: 'intecl/Label/getLabelTypeList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取标签类型选择列表
export function getSelectLabelTypeList(token){
  return request({
    url: 'intecl/Label/getSelectLabelTypeList',
    method: 'post',
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑标签类型
export function saveLabelType(data,token){
  return request({
    url: 'intecl/Label/saveLabelType',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 删除标签类型
export function delLabelType(data,token){
  return request({
    url: 'intecl/Label/delLabelType',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 标签列表
export function getLabelList(data,token){
  return request({
    url: 'intecl/Label/getLabelList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取标签详情
export function getLabelDetail(data,token){
  return request({
    url: 'intecl/Label/getLabelDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑标签
export function saveLabelDetail(data,token){
  return request({
    url: 'intecl/Label/saveLabelDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 删除标签
export function delLabelDetail(data,token){
  return request({
    url: 'intecl/Label/delLabelDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 根据类型获取标签
export function getTypeLabelList(data,token){
  return request({
    url: 'intecl/Label/getTypeLabelList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 机构列表
export function getOrgList(data,token){
  return request({
    url: 'intecl/Org/getOrgList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取机构详情
export function getOrgDetail(data,token){
  return request({
    url: 'intecl/Org/getOrgDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加机构
export function addOrg(data,token){
  return request({
    url: 'intecl/Org/addOrg',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 编辑机构
export function updateOrg(data,token){
  return request({
    url: 'intecl/Org/updateOrg',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}


// 更改机构状态
export function updateOrgStatus(data,token){
  return request({
    url: 'intecl/Org/updateOrgStatus',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 增加会员周期
export function addOrgVip(data,token){
  return request({
    url: 'intecl/Org/addOrgVip',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 学员列表
export function getStudentList(data,token){
  return request({
    url: 'intecl/Student/getStudentList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取学员详情
export function getStudentDetail(data,token){
  return request({
    url: 'intecl/Student/getStudentDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑学员
export function saveStudent(data,token){
  return request({
    url: 'intecl/Student/saveStudent',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 删除学员
export function delStudent(data,token){
  return request({
    url: 'intecl/Student/delStudent',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 导入学员
export function importStudent(data,token){
  return request({
    url: 'intecl/Student/importStudent',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取老师列表
export function getTeacherList(data,token){
  return request({
    url: 'intecl/Teacher/getTeacherList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取老师详情
export function getTeacherDetail(data,token){
  return request({
    url: 'intecl/Teacher/getTeacherDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑老师
export function saveTeacher(data,token){
  return request({
    url: 'intecl/Teacher/saveTeacher',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 删除老师
export function delTeacher(data,token){
  return request({
    url: 'intecl/Teacher/delTeacher',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 批量导入老师
export function importTeacher(data,token){
  return request({
    url: 'intecl/Teacher/importTeacher',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取ai识别
export function getAiRecognition(data,token){
  return request({
    url: 'intecl/Topic/getAiRecognition',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 视频包列表
export function getVideoPackageList(data,token){
  return request({
    url: 'intecl/Video/getVideoPackageList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取视频包选择列表
export function getVideoPackageSelectList(data,token){
  return request({
    url: 'intecl/Video/getVideoPackageSelectList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取视频包详情
export function getVideoPackageDetail(data,token){
  return request({
    url: 'intecl/Video/getVideoPackageDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑视频包
export function saveVideoPackage(data,token){
  return request({
    url: 'intecl/Video/saveVideoPackage',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 更改视频包状态
export function updateVideoPackageStatus(data,token){
  return request({
    url: 'intecl/Video/updateVideoPackageStatus',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 题目选择列表
export function getTopicSelectList(data,token){
  return request({
    url: 'intecl/Topic/getTopicSelectList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取阅读营销列表
export function getReadList(data,token){
  return request({
    url: 'intecl/Marketing/getReadList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取阅读营销详情
export function getReadDetail(data,token){
  return request({
    url: 'intecl/Marketing/getReadDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑阅读营销
export function saveRead(data,token){
  return request({
    url: 'intecl/Marketing/saveRead',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑阅读营销母体讲解
export function saveReadVideo(data,token){
  return request({
    url: 'intecl/Marketing/saveReadVideo',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑阅读营销刻意练习
export function saveReadTopic(data,token){
  return request({
    url: 'intecl/Marketing/saveReadTopic',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 更改阅读状态
export function updateReadStatus(data,token){
  return request({
    url: 'intecl/Marketing/updateReadStatus',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 删除阅读
export function delRead(data,token){
  return request({
    url: 'intecl/Marketing/delRead',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取阅读营销-学员作业列表
export function getReadStudentList(data,token){
  return request({
    url: 'intecl/Marketing/getReadStudentList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}


// 学生or家长
// 密码登录
export function passwordLoginStudent(data){
  return request({
    url: 'intecl/Login/passwordLoginStudent',
    method: 'post',
    data:data,
  })
}

// 验证码登录
export function captchaLoginStudent(data){
  return request({
    url: 'intecl/Login/captchaLoginStudent',
    method: 'post',
    data:data,
    
  })
}

// 退出登录
export function logoutStudent(data,token){
  return request({
    url: 'intecl/Login/logoutStudent',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 切换用户
export function switchUsers(data,token){
  return request({
    url: 'intecl/Login/switchUsers',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 忘记密码
export function retrievePassword(data){
  return request({
    url: 'intecl/Login/retrievePassword',
    method: 'post',
    data:data,
  })
} 

// 首页--家长/小孩
export function indexData(token){
  return request({
    url: 'intecl/Api/index',
    method: 'post',
    headers:{
      'userToken':token
    }
  })
}

// 获取现代文详情
export function getArticleDetail(data,token){
  return request({
    url: 'intecl/Api/getReadDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取母体讲解列表详情
export function getReadVideo(data,token){
  return request({
    url: 'intecl/Api/getReadVideo',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 生成视频观看记录
export function addReadVideoWatch(data,token){
  return request({
    url: 'intecl/Api/addReadVideoWatch',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 生成母体讲解点评信息
export function addReadVideoComment(data,token){
  return request({
    url: 'intecl/Api/addReadVideoComment',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 刷新母题讲解点评
export function refreshVideoComment(data,token){
  return request({
    url: 'intecl/Api/refreshVideoComment',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取视频小节列表信息
export function getReadVideoDetail(data,token){
  return request({
    url: 'intecl/Api/getReadVideoDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取练习列表详情
export function getReadTopic(data,token){
  return request({
    url: 'intecl/Api/getReadTopic',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取练习素材及小题
export function getReadTopicDetail(data,token){
  return request({
    url: 'intecl/Api/getReadTopicDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 刷新练习回答判断
export function refreshTopicJudge(data,token){
  return request({
    url: 'intecl/Api/refreshTopicJudge',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 刷新练习点评
export function refreshTopicComment(data,token){
  return request({
    url: 'intecl/Api/refreshTopicComment',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 刷新练习错题分析
export function refreshAiErrorTopic(data,token){
  return request({
    url: 'intecl/Api/refreshAiErrorTopic',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取错题列表
export function getReadWrongTopic(data,token){
  return request({
    url: 'intecl/Api/getReadWrongTopic',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取错题详情
export function getReadWrongTopicDetail(data,token){
  return request({
    url: 'intecl/Api/getReadWrongTopicDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 去复盘--生成点评
export function addReadWrongTopic(data,token){
  return request({
    url: 'intecl/Api/addReadWrongTopic',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 刷新复盘点评
export function refreshWrongTopicComment(data,token){
  return request({
    url: 'intecl/Api/refreshWrongTopicComment',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 报告--小孩/家长
export function getReport(data,token){
  return request({
    url: 'intecl/Api/getReport',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 生成错题分析和点评
export function addReadTopicComment(data,token){
  return request({
    url: 'intecl/Api/addReadTopicComment',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 生成答案
export function addReadTopicAnswer(data,token){
  return request({
    url: 'intecl/Api/addReadTopicAnswer',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取阅读营销-学员作业母题讲解
export function getReadStudentVideo(data,token){
  return request({
    url: 'intecl/Marketing/getReadStudentVideo',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取阅读营销-学员作业刻意练习
export function getReadStudentTopic(data,token){
  return request({
    url: 'intecl/Marketing/getReadStudentTopic',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取阅读营销-保存老师评语
export function addTeacherComment(data,token){
  return request({
    url: 'intecl/Marketing/addTeacherComment',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取阅读营销-学员作业报告
export function getReadStudentReport(data,token){
  return request({
    url: 'intecl/Marketing/getReadStudentReport',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取阅读营销-老师纠错
export function addTeacherJudge(data,token){
  return request({
    url: 'intecl/Marketing/addTeacherJudge',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 增加有效期
export function addDeadline(data,token){
  return request({
    url: 'intecl/Teacher/addDeadline',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 增加有效期--学生
export function addStudentDeadline(data,token){
  return request({
    url: 'intecl/Student/addDeadline',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 考情诊断列表
export function getExamSitList(data,token){
  return request({
    url: 'intecl/Exam/getExamSitList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加考情诊断
export function saveExamSit(data,token){
  return request({
    url: 'intecl/Exam/saveExamSit',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取考试列表
export function getExamList(data,token){
  return request({
    url: 'intecl/Exam/getExamList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 根据板块和考点
export function getModelAndSiteList(data,token){
  return request({
    url: 'intecl/ModelSet/getModelAndSiteList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取标签列表
export function getModelLabelList(data,token){
  return request({
    url: 'intecl/ModelSet/getLabelList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑标签
export function saveLabelDetail_model(data,token){
  return request({
    url: 'intecl/ModelSet/saveLabelDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取标签详情
export function getLabelDetail_model(data,token){
  return request({
    url: 'intecl/ModelSet/getLabelDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// ai生成考点
export function addAiExamSite(data,token){
  return request({
    url: 'intecl/Exam/addAiExamSite',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取考试详情
export function getExamDetail(data,token){
  return request({
    url: 'intecl/Exam/getExamDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑考试
export function saveExam(data,token){
  return request({
    url: 'intecl/Exam/saveExam',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 删除试卷
export function delExam(data,token){
  return request({
    url: 'intecl/Exam/delExam',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取全部考试列表
export function getExamSelectList(token){
  return request({
    url: 'intecl/Exam/getExamSelectList',
    method: 'post',
    headers:{
      'userToken':token
    }
  })
}

// 导入学生答案
export function importExamAnswer(data,token){
  return request({
    url: 'intecl/Exam/importExamAnswer',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 根据题号生成错题分析
export function addErrorAnalysis(data,token){
  return request({
    url: 'intecl/Exam/addErrorAnalysis',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// ai生成错因分析
export function addAiAnalysis(data,token){
  return request({
    url: 'intecl/Exam/addAiAnalysis',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取板块列表
export function getExamModelList(data,token){
  return request({
    url: 'intecl/Exam/getExamModelList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 删除考情诊断
export function delExamSit(data,token){
  return request({
    url: 'intecl/Exam/delExamSit',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 考情诊断详情
export function getExamSitDetail(data,token){
  return request({
    url: 'intecl/Exam/getExamSitDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}


// 历史考情诊断列表
export function getHistoryExamSitList(data,token){
  return request({
    url: 'intecl/Exam/getHistoryExamSitList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取历史考情诊断报告统计
export function getHistoryExamSitStatistics(data,token){
  return request({
    url: 'intecl/Exam/getHistoryExamSitStatistics',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取历史考情诊断报告
export function getHistoryExamSitReport(data,token){
  return request({
    url: 'intecl/Exam/getHistoryExamSitReport',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}


// 获取考情统计
export function getExamSitStatistics(token){
  return request({
    url: 'intecl/Api/getExamSitStatistics',
    method: 'post',
    headers:{
      'userToken':token
    }
  })
}


// 获取考情诊断报告
export function getExamSitReport(data,token){
  return request({
    url: 'intecl/Api/getExamSitReport',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 报告导出excel
export function exportExam(token){
  return request({
    url: 'intecl/Exam/exportExam',
    method: 'post',
    headers:{
      'userToken':token
    }
  })
}

// 题目列表
export function solveGetTopicList(data,token){
  return request({
    url: 'intecl/ReversePs/getTopicList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑题目
export function solveSaveTopic(data,token){
  return request({
    url: 'intecl/ReversePs/saveTopic',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 删除题目
export function solveDelTopic(data,token){
  return request({
    url: 'intecl/ReversePs/delTopic',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取题目详情
export function solveGetTopicDetail(data,token){
  return request({
    url: 'intecl/ReversePs/getTopicDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取视频包列表
export function solveGetVideoPackageList(data,token){
  return request({
    url: 'intecl/ReversePs/getVideoPackageList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取视频包详情
export function solveGetVideoPackageDetail(data,token){
  return request({
    url: 'intecl/ReversePs/getVideoPackageDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 更改视频包状态
export function solveUpdateVideoPackageStatus(data,token){
  return request({
    url: 'intecl/ReversePs/updateVideoPackageStatus',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编剧视频包
export function solveSaveVideoPackage(data,token){
  return request({
    url: 'intecl/ReversePs/saveVideoPackage',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 题目选择列表
export function solveGetTopicSelectList(data,token){
  return request({
    url: 'intecl/ReversePs/getTopicSelectList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}
// 作文
// 题目列表
export function CompositionTopicList(data,token){
  return request({
    url: 'intecl/Composition/getTopicList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 获取题目详情
export function CompositionTopicDetail(data,token){
  return request({
    url: 'intecl/Composition/getTopicDetail',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 添加/编辑题目
export function CompositionSaveTopic(data,token){
  return request({
    url: 'intecl/Composition/saveTopic',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 删除题目
export function CompositionDelTopic(data,token){
  return request({
    url: 'intecl/Composition/delTopic',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}

// 题目选择列表
export function CompositionTopicSelectList(data,token){
  return request({
    url: 'intecl/Composition/getTopicSelectList',
    method: 'post',
    data:data,
    headers:{
      'userToken':token
    }
  })
}


// WEBPACK FOOTER //
// ./src/assets/js/api.js